import React from "react";

import { SecondaryLayoutTopBannerRenderer } from "./components";
import { SecondaryLayoutTopBannerContextProvider } from "./context";

export const SecondaryLayoutTopBanner: React.FC = () => {
  return (
    <SecondaryLayoutTopBannerContextProvider>
      <SecondaryLayoutTopBannerRenderer />
    </SecondaryLayoutTopBannerContextProvider>
  );
};
